// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__YLkpw","choiceBoxes":"toolbarselects_choiceBoxes__2HWRX","simpleField":"toolbarselects_simpleField__1Yl_8"};